import { render, staticRenderFns } from "./PcSolve.vue?vue&type=template&id=17efe446&scoped=true&"
import script from "./PcSolve.vue?vue&type=script&lang=js&"
export * from "./PcSolve.vue?vue&type=script&lang=js&"
import style0 from "./PcSolve.vue?vue&type=style&index=0&id=17efe446&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17efe446",
  null
  
)

export default component.exports